import { formatDate } from "date-fns";
import { nl } from "date-fns/locale";

export const formatDay = (date: Date) => {
  return formatDate(date, "EEEEEE d MMM", { locale: nl });
};

export const isValidPrice = (price: number | undefined): price is number =>
  price !== undefined && isFinite(price);

export const formatPrice = (price: number | undefined) => {
  if (price === undefined) return undefined;
  if (price === 0) return "Gratis";
  return price.toLocaleString("nl-NL", { style: "currency", currency: "EUR" });
};
